import { tableDefaults } from '../../common';

const defaultPagination = {
  page: 1,
  perPage: tableDefaults.perPage,
  orderBy: tableDefaults.orderBy
};

// Billing list lands sorted by Last 30D Tokens desc by default so the
// highest-usage accounts are at the top. The backend routes this sort to
// the wide-aggregation path; if perf regresses we'll switch to a
// rolled-up BillingAccounts.rolling_month column.
const billingAccountDefaultPagination = {
  page: 1,
  perPage: tableDefaults.perPage,
  orderBy: '-rolling_month'
};

export const defaultState: TableState = {
  unifiedUsersPagination: defaultPagination,
  coreAccountsPagination: defaultPagination,
  coreContactsPagination: defaultPagination,
  coreOfficesPagination: defaultPagination,
  coreUsersPagination: defaultPagination,
  teamPagination: defaultPagination,
  billingPagination: defaultPagination,
  accountPerformancePagination: defaultPagination,
  billingAccountPagination: billingAccountDefaultPagination,
  openAiPagination: defaultPagination,
  twilioPagination: defaultPagination,
  srtPagination: defaultPagination,
  companyTransactionsLogsPagination: defaultPagination,
  apiKeys: defaultPagination,
  zazuAuditLogsPagination: defaultPagination,
  artifactsPagination: defaultPagination,
  jobsPagination: defaultPagination
};

export default defaultState;
